// extracted by mini-css-extract-plugin
export var fadeInOut = "_4p-3";
export var icon = "_4p-4";
export var savedIndicator = "_4p-2";
export var savingIndicator = "_4p-0";
export var spin = "_4p-1";